// extracted by mini-css-extract-plugin
export default {"modalOverlay":"vi-z","modalContent":"wi-z","header":"xi-z","close":"yi-z"};